module.exports = __webpack_public_path__ + "static/media/tiffani_ashley_bell.714b3953.png";